import type { AnyRoute } from './route.ts'

export const toRouteMatcher = (route: AnyRoute): string =>
  route.match.wildcard ? `${route.pattern}(.*)` : route.pattern
